import { RESOURCE_COLOR_MAP } from "@/constants/resource-const"
import { LOCKED_FILL, LOCKED_SIZE, LOCKED_STROKE, STROKE, UNIT_FILL } from "./monitoring-const"

const MonitoringMinimap = ({ unitMap, selectedState, hoveredResource }) => {
  const unitNos = Object.keys(unitMap).map(Number)

  if (unitNos.length === 0) {
    return (
      <div className="h-32 flex text-slate- items-center justify-center text-sm text-gray-400">
        배치도 없음
      </div>
    )
  }

  const floors = [...new Set(unitNos.map((v) => Math.floor(v / 100)))].sort((a, b) => b - a)

  const hos = [...new Set(unitNos.map((v) => v % 100))].sort((a, b) => a - b)

  const CELL_WIDTH = 60
  const CELL_HEIGHT = 28

  const BADGE_SIZE = 7
  const BADGE_GAP = 2
  const BADGE_START_X = 4
  const BADGE_Y = 3

  return (
    <svg width={hos.length * CELL_WIDTH} height={floors.length * CELL_HEIGHT} className="mx-auto">
      {floors.map((floor, yIdx) =>
        hos.map((ho, xIdx) => {
          const unitNo = floor * 100 + ho
          const unit = unitMap[unitNo]

          // 1. 아예 없는 호실은 그리지 않음
          if (unit === undefined) {
            return null
          }

          const { size, badges } = unit

          const x = xIdx * CELL_WIDTH
          const y = yIdx * CELL_HEIGHT

          return (
            <g key={unitNo}>
              <rect
                x={x}
                y={y}
                width={CELL_WIDTH - 1}
                height={CELL_HEIGHT - 1}
                fill={size === LOCKED_SIZE ? LOCKED_FILL : UNIT_FILL}
                stroke={STROKE}
                strokeWidth={0.5}
              />

              {badges.map((badge, idx) => {
                const opactiyCase = () => {
                  if (selectedState === "all") {
                    if (!hoveredResource) return "opacity-100"
                    if (hoveredResource === badge) return "opacity-100"
                    return "opacity-20"
                  } else if (selectedState) {
                    if (!hoveredResource) return "opacity-100"
                    if (hoveredResource === badge) return "opacity-100"
                    return "opacity-20"
                  } else {
                    return "opacity-20"
                  }
                }

                const detecting = () => {
                  if (selectedState === "all") {
                    if (!hoveredResource) return ""
                    if (hoveredResource === badge) return "radar-detecting"
                    return ""
                  } else if (selectedState) {
                    if (!hoveredResource) return ""
                    if (hoveredResource === badge) return "radar-detecting"
                    return ""
                  } else {
                    return ""
                  }
                }

                return (
                  <g key={`${unitNo}-${badge}`}>
                    <circle
                      className={detecting()}
                      cx={x + BADGE_START_X + idx * (BADGE_SIZE + BADGE_GAP) + BADGE_SIZE / 2}
                      cy={y + BADGE_Y + BADGE_SIZE / 2}
                      r={
                        selectedState && hoveredResource === badge
                          ? (BADGE_SIZE + 2) / 2
                          : BADGE_SIZE / 2
                      }
                      fill={RESOURCE_COLOR_MAP[badge] || "#9ca3af"}
                      opacity={0}
                    />
                    <circle
                      className={`
                      transition-all duration-300
                      ${opactiyCase()}
                      `}
                      key={`${unitNo}-${badge}`}
                      cx={x + BADGE_START_X + idx * (BADGE_SIZE + BADGE_GAP) + BADGE_SIZE / 2}
                      cy={y + BADGE_Y + BADGE_SIZE / 2}
                      r={
                        selectedState && hoveredResource === badge
                          ? (BADGE_SIZE + 2) / 2
                          : BADGE_SIZE / 2
                      }
                      fill={RESOURCE_COLOR_MAP[badge] || "#9ca3af"}
                    />
                  </g>
                )
              })}

              <text
                x={xIdx * CELL_WIDTH + CELL_WIDTH / 2}
                y={yIdx * CELL_HEIGHT + CELL_HEIGHT / 2 + 4}
                textAnchor="middle"
                fontSize={10}
              >
                {unitNo}
              </text>

              {/* 2. LOCKED는 X 표시 */}
              {size === LOCKED_SIZE && (
                <>
                  <line
                    x1={x + 2}
                    y1={y + 2}
                    x2={x + CELL_WIDTH - 3}
                    y2={y + CELL_HEIGHT - 3}
                    stroke={LOCKED_SIZE ? LOCKED_STROKE : STROKE}
                    strokeWidth={1}
                  />

                  <line
                    x1={x + CELL_WIDTH - 3}
                    y1={y + 2}
                    x2={x + 2}
                    y2={y + CELL_HEIGHT - 3}
                    stroke={LOCKED_SIZE ? LOCKED_STROKE : STROKE}
                    strokeWidth={1}
                  />
                </>
              )}
            </g>
          )
        })
      )}
    </svg>
  )
}

export default MonitoringMinimap
